import { Banner, TextLink } from 'slab'

export const UnrecoverableErrorBanner = () => {
  return (
    <Banner title="Hmm… something's not right" type='warning'>
      <div>
        Please reach out to{' '}
        <TextLink href='mailto:support@thatch.com' target='_blank'>
          support@thatch.com
        </TextLink>{' '}
        for help.
      </div>
    </Banner>
  )
}
